const TYPES = {
    GET_AFFILIATE_AGREEMENT: 'GET_AFFILIATE_AGREEMENT',
    GET_AFFILIATE_AGREEMENT_COMPLETE: 'GET_AFFILIATE_AGREEMENT_COMPLETE',
    GET_AFFILIATE_AGREEMENT_FAILED: 'GET_AFFILIATE_AGREEMENT_FAILED',

    GET_CONDUCT_AGREEMENT: 'GET_CONDUCT_AGREEMENT',
    GET_CONDUCT_AGREEMENT_COMPLETE: 'GET_CONDUCT_AGREEMENT_COMPLETE',
    GET_CONDUCT_AGREEMENT_FAILED: 'GET_CONDUCT_AGREEMENT_FAILED'
};

export default {
    TYPES,

    getAffiliateAgreement: () => ({
        type: TYPES.GET_AFFILIATE_AGREEMENT
    }),

    getAffiliateAgreementSuccess: (payload?) => ({
        type: TYPES.GET_AFFILIATE_AGREEMENT_COMPLETE,
        payload
    }),

    getAffiliateAgreementFailed: (error?) => ({
        type: TYPES.GET_AFFILIATE_AGREEMENT_FAILED,
        payload: {error}
    }),

    getConductAgreement: () => ({
        type: TYPES.GET_CONDUCT_AGREEMENT
    }),

    getConductAgreementSuccess: (payload?) => ({
        type: TYPES.GET_CONDUCT_AGREEMENT_COMPLETE,
        payload
    }),

    getConductAgreementFailed: (error?) => ({
        type: TYPES.GET_CONDUCT_AGREEMENT_FAILED,
        payload: {error}
    })
};
